import { Say } from "../../../arc/locale/consts";

const eventStatusSayIds = {
    concept:"eventStatusConcept",
    draft:"eventStatusConcept"
};

const statusSayId = (prefix, map, status)=>status && (map[status] || Say.id(prefix, status));

const sayStatus = (say, prefix, map, status)=>{
    const id = statusSayId(prefix, map, status);
    return id ? say(id) : "";
};

export const sayEventStatus = (say, status)=>sayStatus(say, "eventStatus", eventStatusSayIds, status);

export const sayEventSignStatus = (say, status)=>sayStatus(say, "eventSignStatus", {}, status);

export const sayEventAvMode = (say, mode)=>{
    return mode ? say(Say.id("eventRecord", mode)) : "";
};

export const sayEventAvModes = (say, modes=[])=>{
    return modes.length
        ? modes.map(mode=>sayEventAvMode(say, mode)).join(", ")
        : say("eventRecordNone");
};
